export const SET_CATEGORIES = 'categories/set-categories';
export const SET_CATEGORY_SETTING = 'categories/set-category-setting';
export const SET_CATEGORY_EXPANDED = 'categories/set-category-expanded';
export const SET_CATEGORY_LOADING = 'categories/set-category-loading';
export const SET_CATEGORY_LOADED = 'categories/set-category-loaded';
export const SET_SELECTED_CATEGORY = 'categories/set-category-selected';
export const REMOVE_CATEGORY = 'categories/remove-category';
export const SET_REFERENCES = 'categories/set-references';
export const ADD_ERRORS = 'errors/add-errors';
export const SET_CATEGORY_TREE_FETCHED = 'categories/set-category-tree-fetched';
